import Pagination from 'rc-pagination/lib/locale/fi_FI';
import Calendar from '../calendar/locale/fi_FI';
import DatePicker from '../date-picker/locale/fi_FI';
import TimePicker from '../time-picker/locale/fi_FI';
const localeValues = {
    locale: 'fi',
    Pagination,
    DatePicker,
    TimePicker,
    Calendar,
    Table: {
        filterTitle: 'Suodatus valikko',
        filterConfirm: 'OK',
        filterReset: 'Tyhjennä',
        selectAll: 'Valitse kaikki',
        selectInvert: 'Valitse päinvastoin',
        sortTitle: 'Lajittele',
        triggerDesc: 'Lajittele laskevasti',
        triggerAsc: 'Lajittele nousevasti',
        cancelSort: 'Peruuta lajittelu',
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Peruuta',
        justOkText: 'OK',
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Peruuta',
    },
    Transfer: {
        searchPlaceholder: 'Etsi täältä',
        itemUnit: 'kohde',
        itemsUnit: 'kohdetta',
    },
    Upload: {
        uploading: 'Lähetetään...',
        removeFile: 'Poista tiedosto',
        uploadError: 'Virhe lähetyksessä',
        previewFile: 'Esikatsele tiedostoa',
        downloadFile: 'Lataa tiedosto',
    },
    Empty: {
        description: 'Ei kohteita',
    },
    Text: {
        edit: 'Muokkaa',
        copy: 'Kopioi',
        copied: 'Kopioitu',
        expand: 'Näytä lisää',
    },
};
export default localeValues;
